import { render, staticRenderFns } from "./AddCompany.vue?vue&type=template&id=6c76dc0c&"
import script from "./AddCompany.vue?vue&type=script&lang=js&"
export * from "./AddCompany.vue?vue&type=script&lang=js&"
import style0 from "./AddCompany.vue?vue&type=style&index=0&id=6c76dc0c&prod&lang=scss&"
import style1 from "./AddCompany.vue?vue&type=style&index=1&id=6c76dc0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports